import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, MessageCircle } from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "../ui/sheet";
import { useConfig } from "../../lib/config";
import { waLink } from "../../lib/api";

const NAV = [
  { label: "Inicio", href: "/#inicio" },
  { label: "Productos", href: "/#productos" },
  { label: "¿Por qué AZOO?", href: "/#por-que" },
  { label: "Distribuidores", href: "/#distribuidores" },
  { label: "Consejos", href: "/blog" },
  { label: "Preguntas", href: "/#preguntas" },
];

export function Header() {
  const config = useConfig();
  const [open, setOpen] = useState(false);
  const wa = waLink(config.whatsapp_number || "", "Hola, quiero consultar sobre productos AZOO.");

  return (
    <header className="sticky top-0 z-40 bg-white/95 backdrop-blur border-b border-zinc-200" data-testid="site-header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-4">
        <Link to="/#inicio" className="flex items-center gap-3" data-testid="header-logo-link">
          <img src="/logo-azoo.png" alt="AZOO Costa Rica" className="h-8 w-auto" />
          <span className="hidden lg:inline-block text-[11px] font-semibold text-zinc-500 bg-zinc-100 px-2 py-0.5 rounded">
            Distribuido por Tugeko S.A.
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-6 text-xs font-bold uppercase tracking-wider text-zinc-600" data-testid="header-nav">
          {NAV.map((item) => (
            <Link key={item.label} to={item.href} className="hover:text-brand-600 transition-colors" data-testid={`nav-${item.label.toLowerCase().replace(/[^a-z]/g, "-")}`}>
              {item.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href={wa}
            target="_blank"
            rel="noopener noreferrer"
            className="hidden sm:inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-brand-600 hover:bg-brand-500 text-white font-bold text-xs uppercase tracking-wider transition-colors shadow-sm"
            data-testid="header-whatsapp-button"
          >
            <MessageCircle className="w-4 h-4" /> WhatsApp
          </a>
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <button className="md:hidden p-2 rounded-lg border border-zinc-200" aria-label="Abrir menú" data-testid="mobile-menu-button">
                <Menu className="w-5 h-5" />
              </button>
            </SheetTrigger>
            <SheetContent side="right" className="w-72">
              <SheetTitle className="text-left font-display">Menú</SheetTitle>
              <nav className="mt-6 flex flex-col gap-4 text-sm font-semibold text-zinc-700" data-testid="mobile-nav">
                {NAV.map((item) => (
                  <Link key={item.label} to={item.href} onClick={() => setOpen(false)} className="hover:text-brand-600 transition-colors" data-testid={`mobile-nav-${item.label.toLowerCase().replace(/[^a-z]/g, "-")}`}>
                    {item.label}
                  </Link>
                ))}
                <a href={wa} target="_blank" rel="noopener noreferrer" className="mt-4 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-xl bg-brand-600 text-white font-bold text-sm" data-testid="mobile-whatsapp-button">
                  <MessageCircle className="w-4 h-4" /> Consultar WhatsApp
                </a>
              </nav>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
}
